module.exports = __webpack_public_path__ + "media/small/real_estate_apartments_rent-small-7a3bc671.jpeg";